export default __webpack_public_path__ + "static/media/Accredia-Certing.9920c845.png";